import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import CourseDetails from "../Components/CourseDetails";
import axios from "axios";
import { API_BASE } from "../Utils/constant";
import { useNavigate } from "react-router-dom";
import { AUTH_TOKEN } from "../constants/localStorageKeys";
import { retrieve } from "../helpers/StorageHelper";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = retrieve(AUTH_TOKEN);
    axios
      .get(`${API_BASE}/user/courses`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          setCourses(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching courses:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleStartCourse = (courseId) => {

    setCourses((prevCourses) =>
      prevCourses.map((course) =>
        course.id === courseId ? { ...course, status: "in_progress" } : course,
      ),
    );
  };

  const renderBadgeProps = (status) => {
    switch (status) {
      case "completed":
        return { badgeStatus: "Completed", badgeBtn: "completed" };
      case "in_progress":
        return { badgeStatus: "In Progress", badgeBtn: "in-progress" };
      case "not_started":
      default:
        return { badgeStatus: "Not Started", badgeBtn: "not-started" };
    }
  };

  return (
    <Layout>
      <div className="page-content">
        <div className="setting-content">
          <h1
            className="text-heading-h2"
            style={{ color: "#e6ecf1", marginBottom: "32px" }}
          >
            Courses
          </h1>
          <div className="courses-container">
            {loading ? (
              <div className="loader-container">
                <div className="loader"></div>
              </div>
            ) : courses.length === 0 ? (
              <div className="loader-container">
                <p
                  className="text-center text-body-b2 w-100"
                  style={{ color: "#ccc" }}
                >
                  No courses available.
                </p>
              </div>
            ) : (
              courses.map((course) => {
                const badge = renderBadgeProps(course.status);
                return (
                  <CourseDetails
                    key={course.id}
                    id={course.id}
                    imageSrc={course.thumbnail}
                    progressPercentage={course.completion_percentage}
                    title={course.title}
                    badgeStatus={badge.badgeStatus}
                    badgeBtn={badge.badgeBtn}
                    onStartCourse={handleStartCourse}
                  />
                );
              })
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}
